var _path, _path2, _stop, _stop2, _stop3, _stop4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastInfoV2 = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "toast-info-v2_svg__a)",
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#" + _uid + "toast-info-v2_svg__b)",
    strokeWidth: 0.5,
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.25 8.25h1.5v7.5h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C64F2",
    d: "M12 6a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6m-.23 2.77a.692.692 0 1 1 0 1.384.692.692 0 0 1 0-1.385m.691 6.46a.923.923 0 0 1-.922-.922V12a.462.462 0 1 1 0-.923.923.923 0 0 1 .922.923v2.308a.462.462 0 1 1 0 .923"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-info-v2_svg__a",
    x1: -0.951,
    x2: 12,
    y1: -24.333,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C64F2"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3C"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-info-v2_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F69"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })))));
};
export { SvgToastInfoV2 as ReactComponent };
export default __webpack_public_path__ + "0508dbde6a739a1ef18a5e2e1ccbc1e8.svg";